import { useQuery } from 'react-query';
import axios from 'axios';
import { COSTCENTERS } from 'RestAPIs/endpoints';
import { toLocalISOString } from 'utils/date';
import { Project } from '../../type';

const getProjects = () => axios.get<Project[]>(`/secure/projects`);

export const useGetProjectOptions = () => {
  const { data, isFetching } = useQuery({
    queryKey: ['projects'],
    initialData: undefined,
    queryFn: async () => {
      const { data } = await getProjects();
      return data;
    }
  });

  return { data, isFetching };
};

const getPlanUnits = (startDate, endDate) =>
  axios.get(COSTCENTERS, {
    params: {
      startDate: toLocalISOString(startDate),
      endDate: toLocalISOString(endDate)
    }
  });

export const useGetPlanUnitsOptions = (startDate, endDate) => {
  const { data, isFetching } = useQuery({
    queryKey: ['cost-centers'],
    initialData: undefined,
    queryFn: async () => {
      const { data } = await getPlanUnits(startDate, endDate);
      return data;
    }
  });
  return { data, isFetching };
};
